"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Class = void 0;
const models_1 = require("lincd/lib/models");
const Resource_1 = require("./Resource");
const package_1 = require("../package");
const rdfs_1 = require("../ontologies/rdfs");
const rdf_1 = require("lincd/lib/ontologies/rdf");
const Prefix_1 = require("lincd/lib/utils/Prefix");
let Class = class Class extends Resource_1.Resource {
    getNumLocalInstances(explicitInstancesOnly = false, filterLocalNodes = false) {
        //since we want to use the same filters, and count unique subjects of quads
        //there is no faster way to count the total number without actually building the result set
        //so here we just return the size of the number of local instances with the same filters (and no limit or offset)
        return this.getLocalInstanceResources(explicitInstancesOnly, filterLocalNodes).size;
    }
    getLocalInstanceResources(explicitInstancesOnly = false, filterLocalNodes = false, limit = NaN, offset = 0) {
        let result;
        if (explicitInstancesOnly) {
            if (filterLocalNodes) {
                result = this.node
                    .getInverseQuads(rdf_1.rdf.type)
                    .filter((quad) => !quad.implicit && !quad.subject.isTemporaryNode)
                    .getSubjects();
            }
            else {
                result = this.node
                    .getInverseQuads(rdf_1.rdf.type)
                    .filter((quad) => !quad.implicit)
                    .getSubjects();
            }
        }
        else {
            if (filterLocalNodes) {
                result = this.node.getAllInverse(rdf_1.rdf.type).filter((n) => !n.isTemporaryNode);
            }
            else {
                result = this.node.getAllInverse(rdf_1.rdf.type);
            }
        }
        if (!isNaN(limit)) {
            let start = offset;
            let end = offset + limit;
            result = result.slice(start, end);
        }
        return result;
    }
    get isDefinedBy() {
        return this.getOne(rdfs_1.rdfs.isDefinedBy);
    }
    set isDefinedBy(value) {
        this.overwrite(rdfs_1.rdfs.isDefinedBy, value);
    }
    /**
     * Gets the ontology node that defines this property
     * Uses isDefinedBy but also looks at the URI for known matches with prefixes as a fallback
     */
    get ontology() {
        let isDefinedBy = this.isDefinedBy;
        if (isDefinedBy) {
            return isDefinedBy;
        }
        let [ontologyURI] = Prefix_1.Prefix.findMatch(this.namedNode.uri);
        if (ontologyURI) {
            return models_1.NamedNode.getOrCreate(ontologyURI);
        }
    }
};
Class.targetClass = rdfs_1.rdfs.Class;
Class = __decorate([
    package_1.linkedShape
], Class);
exports.Class = Class;
//# sourceMappingURL=Class.js.map